<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ChannelIcon from 'next/icon/ChannelIcon.vue';
import { PLATFORMS, getInboxPlatform } from 'dashboard/helper/sourcePlatforms';

const props = defineProps({
  inbox: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();

// Source inboxes get the short platform name ("Instagram"), others keep their own name.
const label = computed(() => {
  const platform = PLATFORMS[getInboxPlatform(props.inbox)];
  return platform ? t(platform.name) : props.inbox.name;
});
</script>

<template>
  <span
    v-tooltip.top="inbox.name"
    class="inline-flex items-center gap-1.5 h-6 px-2 rounded-md bg-n-alpha-2 outline outline-1 outline-n-weak text-label-small text-n-slate-12 max-w-40"
  >
    <ChannelIcon :inbox="inbox" use-brand-icon class="size-3.5 flex-shrink-0" />
    <span class="truncate">{{ label }}</span>
  </span>
</template>
